import React from 'react';

type Props = {
  itemsCount: number;
  searchTerm: string;
};

const SearchText = ({ itemsCount, searchTerm }: Props) => {
  if (!searchTerm) return null;

  return (
    <div className='tw-mt-10 tw-flex tw-justify-center'>
      <h3>
        {itemsCount === 0 ? (
          <>We were unable to find results for “{searchTerm}”</>
        ) : (
          itemsCount > 0 && (
            <>
              Showing {itemsCount} result{itemsCount > 1 && 's'} for “{searchTerm}”
            </>
          )
        )}
      </h3>
    </div>
  );
};

export default SearchText;
